/**
 * Short job link /jobs/<username>/<path> (hireai-backend jobs/share_names.py).
 *
 * Looks the job up (public, no login) and opens the normal job page at
 * /jobs/<slug>, keeping the query (s= / r= / utm_*) so the visit is still
 * attributed. An unknown link lands on the jobs list.
 */
import { useEffect, useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { Spin } from "antd";
import instance from "../api/instance";
import { jobByPath } from "../api/apiRoutes";

const ShortJobLinkRedirect = () => {
  const { username, path } = useParams();
  const { search } = useLocation();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    instance
      .get(jobByPath(username, path), { signal: controller.signal })
      .then((res) => {
        const data = res?.data?.data;
        const ref = data?.slug || data?.job_id;
        setTarget(ref ? `/jobs/${encodeURIComponent(ref)}${search}` : "/jobs");
      })
      .catch((err) => {
        if (controller.signal.aborted || err?.name === "CanceledError") return;
        setTarget("/jobs");
      });
    return () => controller.abort();
  }, [username, path, search]);

  if (target) return <Navigate to={target} replace />;
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "96px 16px" }}>
      <Spin size="large" aria-label="Opening the job" />
    </div>
  );
};

export default ShortJobLinkRedirect;
